import { ReactNode } from 'react';
import { useUserRoles } from '@/hooks/useUserRoles';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { ShieldAlert } from 'lucide-react';

type AppRole = 'owner' | 'admin' | 'investor' | 'auditor' | 'observer';

interface RoleGateProps {
  allowedRoles: AppRole[];
  companyId?: string;
  children: ReactNode;
  fallback?: ReactNode;
}

export function RoleGate({ allowedRoles, companyId, children, fallback }: RoleGateProps) {
  const { hasAnyRole, loading } = useUserRoles(companyId);

  if (loading) {
    return null;
  }

  const isAllowed = hasAnyRole(allowedRoles, companyId);

  if (isAllowed) {
    return <>{children}</>;
  }

  if (fallback) {
    return <>{fallback}</>;
  }

  return (
    <Alert variant="destructive">
      <ShieldAlert className="h-4 w-4" />
      <AlertDescription>You do not have permission to access this content.</AlertDescription>
    </Alert>
  );
}
